export default "__VITE_ASSET__Dt8tRbKa__"